import { AllLeaguesSchema } from '@/views/sports/AllLeagues/styles/AllLeagues.styles';

export const allLeaguesStyles: AllLeaguesSchema = {
  headerSportText: {
    fontSize: 'sm',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.20)',
    color: 'white',
    fontFamily: 'Bowlby One',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    letterSpacing: 'widest',
  },
  boxWrapper: {
    px: 0,
    mt: '-2',
  },
  accordionButton: {
    sx: {
      display: 'flex',
      p: '3',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      borderTopRadius: 'md',
      border: 'none',
      fontSize: 'sm',
    },
  },
  accordionPanelBoxInner: {
    mb: '2',
  },
  accordionPanelBoxInnerLink: {
    color: 'white',
    fontSize: 'xs',
    fontWeight: 'normal',
    sx: { _hover: { textDecoration: 'none' } },
  },
  marketGroupsByLetterHeadingText: {
    sx: {
      fontFamily: 'accent',
      color: 'white',
      fontsize: 'xl',
      my: '2',
      fontWeight: 'normal',
    },
  },
  topLeaguesAccordionItem: {
    mt: '3',
    borderBottomRadius: 'base',
    p: '1px',
    bg: 'rgba(78, 178, 255, 0.14)',
    borderRadius: 'md',
    boxShadow:
      '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
    _hover: {
      bg: 'rgba(78, 178, 255, 0.45)',
    },
  },
  marketGroupsByLetterAccordionItem: {
    border: 'none',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.1) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.3)',
    bg: 'rgba(78, 178, 255, 0.14)',
    borderRadius: 'md',
    mb: '2',
    sx: {
      _last: {
        button: {
          _last: {
            borderBottomRadius: 'md',
            _hover: {
              bg: 'rgba(78, 178, 255, 0.45)',
            },
          },
        },
      },
      _first: {
        button: {
          _first: { borderTopRadius: 'md', border: 'none' },
          _hover: {
            bg: 'rgba(78, 178, 255, 0.45)',
          },
        },
      },
    },
  },
  marketGroupsByLetterAccordionButton: {
    color: 'white',
    sx: {
      display: 'flex',
      p: '3',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      borderRadius: 'unset',
    },
  },
  marketGroupsByLetterTitleText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'normal',
    color: 'white',
    fontFamily: 'accent',
    fontSize: 'sm',
    sx: {
      img: {
        borderRadius: 'base',
      },
    },
  },
  marketGroupsByLetterCountryFlag: {
    marginRight: '10px',
    width: '1.2em',
    height: '1.2em',
  },
  marketGroupsByLetterAccordionPanel: {
    px: '3',
    pb: '3',
  },
  marketGroupsByLetterAccordionIcon: {
    color: 'alpha.400',
  },
  marketGroupsByLetterAccordionPanelBox: {
    borderLeftWidth: '2px',
    borderColor: 'alpha.400',
    px: '2',
  },
  marketGroupsByLetterAccordionPanelLink: {
    color: 'white',
    fontSize: 'sm',
    fontWeight: 'normal',
    sx: { _hover: { textDecoration: 'none' } },
  },
  accordionIcon: { color: 'alpha.400' },
  accordionPanel: {
    px: '2',
    py: '0',
  },
  accordionPanelBoxWrapper: {
    borderLeftWidth: '2px',
    borderColor: 'alpha.400',
    px: '2',
  },
  topLeaguesText: {
    flex: '1',
    textAlign: 'left',
    fontWeight: 'normal',
    fontFamily: 'accent',
    color: 'white',
    fontSize: 'sm',
    px: 0,
  },
  navWrapper: {
    pb: '0',
  },
};
